"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pageJumpCreateApi = pageJumpCreateApi;
exports.pageJumpDeleteApi = pageJumpDeleteApi;
exports.pageJumpInfoApi = pageJumpInfoApi;
exports.pageJumpListApi = pageJumpListApi;
exports.pageJumpPlaceholdersApi = pageJumpPlaceholdersApi;
exports.pageJumpSwitchApi = pageJumpSwitchApi;
exports.pageJumpUpdateApi = pageJumpUpdateApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 分页查询分享配置列表
 */
function pageJumpListApi(params) {
  return (0, _request.default)({
    url: "/admin/share/config/list",
    method: 'GET',
    params: params
  });
}

/**
 * 分享文案占位符列表
 */
function pageJumpPlaceholdersApi() {
  return (0, _request.default)({
    url: "/admin/share/config/placeholders",
    method: 'GET'
  });
}

/**
 * 分享配置详情
 */
function pageJumpInfoApi(id) {
  return (0, _request.default)({
    url: "/admin/share/config/info",
    method: 'GET',
    params: {
      id: id
    }
  });
}

/**
 * 新增/保存分享配置
 */
function pageJumpCreateApi(data) {
  return (0, _request.default)({
    url: "/admin/share/config/save",
    method: 'POST',
    data: data
  });
}

/**
 * 编辑分享配置
 */
function pageJumpUpdateApi(data) {
  return (0, _request.default)({
    url: "/admin/share/config/update",
    method: 'POST',
    data: data
  });
}

/**
 * 删除分享配置
 */
function pageJumpDeleteApi(id) {
  return (0, _request.default)({
    url: "/admin/share/config/delete",
    method: 'POST',
    data: {
      id: id
    }
  });
}

/**
 * 切换状态
 */
function pageJumpSwitchApi(id, status) {
  return (0, _request.default)({
    url: "/admin/share/config/updateStatus",
    method: 'POST',
    data: {
      id: id,
      status: status
    }
  });
}